<script>
  import ReportCardContactDetails from "./../components/ReportCardContactDetails.svelte";
  import { link } from "svelte-spa-router";
  import Container from "./../shared/Container.svelte";
  import SectionHeading from "./../shared/SectionHeading.svelte";
  import Layout from "../Layout/Layout.svelte";
  import Modal from "../shared/Modal.svelte";
  import config from "../stores/config";
  import axios from "axios";
  import * as ls from "local-storage";
  import { Circle2 } from "svelte-loading-spinners";
  import ReportCard from "../components/ReportCard.svelte";
  import { onMount } from "svelte";
  import Loading from "../shared/Loading.svelte";
  import Empty from "../shared/Empty.svelte";
  import * as animateScroll from "svelte-scrollto";

  export let params = {};

  // Adding A New Report -------------------------------------------------------------------
  let report = null;

  let showAddReportForm = false;
  let addNewReportLoading = false;

  const handleAddNewReport = async (e) => {
    addNewReportLoading = true;

    axios
      .post(
        `${$config.backendURL}/reports`,
        {
          userID: params._id,
          addedBy: $config.currentUser.username,
          content: report,
        },
        {
          headers: { authorization: ls.get("jwt") },
        }
      )
      .then((res) => {
        showAddReportForm = false;
        addNewReportLoading = false;
        report = null;

        fetchReports();
      })
      .catch((err) => {
        addNewReportLoading = false;
        console.log(err);
        alert(err);
      });
  };

  // Query For Contact & His Reports --------------------------------------------------------------------
  let reports = null;
  let contact = null;

  const fetchReports = async () => {
    reports = null;
    contact = null;

    await Promise.all([
      axios.get(`${$config.backendURL}/contacts/${params._id}`, {
        headers: { authorization: ls.get("jwt") },
      }),
      axios.get(`${$config.backendURL}/reports/user/${params._id}`, {
        headers: { authorization: ls.get("jwt") },
      }),
    ])
      .then((res) => {
        contact = res[0].data;
        reports = res[1].data;
      })
      .catch((e) => {
        console.log(e);
      });
  };

  onMount(() => {
    animateScroll.scrollToTop();
    fetchReports();
  });
</script>

<svelte:head>
  <title>View Reports/Notes | SAMAKI EXPRESS</title>
</svelte:head>

<Layout>
  <Modal
    show={showAddReportForm}
    on:modalClose={() => {
      showAddReportForm = false;
    }}
  >
    <div class="grid gap-y-2">
      <textarea
        bind:value={report}
        type="text"
        placeholder="Write your note/report here..."
        rows="4"
      />
      {#if addNewReportLoading}
        <div class="grid grid-cols-1 gap-8">
          <div class="btn btn-primary">
            <Circle2
              size="25"
              unit="px"
              colorOuter="#F4A261"
              colorCenter="#40B3FF"
              colorInner="#676778"
            />
            <span class="ml-4">Please Wait...</span>
          </div>
        </div>
      {:else}
        <!-- else content here -->
        <div class="flex">
          <button class="btn btn-primary" on:click={handleAddNewReport}>
            <ion-icon name="checkmark-circle" class="text-2xl mr-3" />
            Save
          </button>
          <button
            class="ml-4 btn btn-secondary"
            on:click={(e) => (showAddReportForm = false)}
          >
            <ion-icon name="close-circle" class="text-2xl mr-3" />
            Close
          </button>
        </div>
      {/if}
    </div>
  </Modal>

  {#if reports == null}
    <Loading text="Loading Current Contact..." />
  {:else}
    <SectionHeading text1={`Write Notes & Reports`} />

    <Container>
      <ReportCardContactDetails {...contact} />
      <div class="grid grid-cols-1 mt-6">
        <a
          class="btn bg-gradient-to-r from-red-500 to-red-300"
          use:link
          href={`/calls/${params._id}`}
          style="width: 100%;"
        >
          <ion-icon name="call" class="text-2xl mr-3" />
          Open Call Reports/Reminders
        </a>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <a class="btn btn-secondary" use:link href="/" style="width: 100%;">
          <ion-icon name="arrow-back-circle" class="text-2xl mr-3" />
          Return to Contacts
        </a>
        <button
          class="btn btn-primary"
          on:click={(e) => {
            showAddReportForm = true;
          }}
          style="width: 100%;"
        >
          <ion-icon name="add-circle" class="text-2xl mr-3" />
          Add A New Note/Report
        </button>
      </div>
    </Container>
  {/if}

  <Container>
    {#if reports == null}
      <Loading text="Loading Reports..." />
    {:else}
      <div class="my-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        {#each reports as rep (rep._id)}
          <ReportCard
            {...rep}
            on:delete={() => {
              fetchReports();
            }}
          />
        {:else}
          <div class="col-span-full">
            <Empty text="No Reports/Notes Written On This Contact" />
          </div>
        {/each}
      </div>
    {/if}
  </Container>
</Layout>
